import { render } from "./view-settings.vue?vue&type=template&id=6ba8cbd4"
import script from "./view-settings.vue?vue&type=script&lang=js"
export * from "./view-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__